import * as React from "react";
import {Record} from "./HaccpTableRow";

import "./HaccpTableCell.scss";

const DEFAULT_NUMBER_OF_FRACTION_DIGITS = 1;

const DIFFERENT_THRESHOLD_WARNING_COLOR = "#FFED00";

export interface HaccpTableCellProps {
    record: Record;
    hour: number;
    texts: {
        lo: string,
        hi: string,
    };
    showExtremes: boolean;
}

export interface HaccpTableCellState {
    hover: boolean;
}

export class HaccpTableCell extends React.Component<HaccpTableCellProps, HaccpTableCellState> {

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
    }

    public render() {

        if (!this.props.record) {
            return (
                <td
                    className={(!((this.props.hour + 1)  % 24) ? " last-hour-col" : "")}
                    style={{
                        backgroundColor: "white",
                        verticalAlign: "middle",
                    }}
                >
                    <div className={"cell-content-wrapper"}>
                        <div className={"HaccpTableCell"}>
                            <div className={"haccp-cell"}>
                                {
                                    this.props.showExtremes
                                        ?   (
                                            <div className={"max-in-hour"}>
                                                <p style={{color: "transparent"}}>-</p>
                                            </div>
                                        ) : null
                                }
                                <p className={"mean-in-hour"}>-</p>
                                {
                                    this.props.showExtremes
                                        ? (
                                            <div className={"min-in-hour"}>
                                                <p style={{color: "transparent"}}>-</p>
                                            </div>
                                        ) : null
                                }
                            </div>
                        </div>
                    </div>
                </td>
            );
        } else if (!this.props.record.mean) {
            return (
                <td
                    className={(!((this.props.hour + 1)  % 24) ? " last-hour-col" : "")}
                    style={{
                        backgroundColor: this.props.record.color,
                        verticalAlign: "middle",
                    }}
                >
                    <div className={"cell-content-wrapper"}>
                        <div className={"HaccpTableCell"}>
                            <div className={"haccp-cell"}>
                                {
                                    this.props.showExtremes
                                        ?   (
                                            <div className={"max-in-hour"}>
                                                <p style={{color: "transparent"}}>-</p>
                                            </div>
                                        ) : null
                                }
                                <p className={"mean-in-hour"}>-</p>
                                {
                                    this.props.showExtremes
                                        ? (
                                            <div className={"min-in-hour"}>
                                                <p style={{color: "transparent"}}>-</p>
                                            </div>
                                        ) : null
                                }
                            </div>
                        </div>
                    </div>
                </td>
            );
        }

        return (
            <td
                className={!((this.props.hour + 1)  % 24) ? " last-hour-col" : ""}
                style={{
                    verticalAlign: "middle",
                }}
            >
                <div className={"cell-content-wrapper"}>
                    <div className={"HaccpTableCell"}>
                        {
                            this.state.hover && this.props.record.thresholdsChanged
                                ? (
                                    <div
                                        className={"thresholds-explanation"}
                                        style={{zIndex: 5}}
                                    >
                                        <p>
                                            {this.props.texts.hi}
                                        </p>
                                        <p
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {Number(this.props.record.hi).toFixed(
                                            Math.abs(this.props.record.hi) >= 100
                                                ? 0
                                                : DEFAULT_NUMBER_OF_FRACTION_DIGITS,
                                        )}°
                                        </p>
                                        <p>
                                            {this.props.texts.lo}</p>
                                        <p
                                            style={{
                                            fontWeight: "bold",
                                            }}
                                        >
                                            {Number(this.props.record.lo).toFixed(
                                            Math.abs(this.props.record.lo) >= 100
                                                ? 0 :
                                                DEFAULT_NUMBER_OF_FRACTION_DIGITS,
                                        )}°
                                        </p>
                                    </div>
                                )
                                : null
                        }
                        <div
                            className={"haccp-cell"}
                            onMouseEnter={this.toggleHover(true)}
                            onMouseLeave={this.toggleHover(false)}
                            style={{
                                opacity: this.state.hover ? .5 : 1,
                                backgroundColor: !this.props.record.mean ? this.props.record.color : undefined,
                            }}
                        >
                            {
                                this.props.showExtremes
                                    ?   (
                                        <div
                                            className={"max-in-hour"}
                                            style={{
                                                backgroundColor: this.props.record.maxBgColor,
                                                color: this.props.record.maxTxColor,
                                            }}
                                        >
                                            <p>
                                                {this.props.record.max.toFixed(DEFAULT_NUMBER_OF_FRACTION_DIGITS) + "°"}
                                            </p>
                                        </div>
                                    ) : null
                            }
                            <p
                                className={"mean-in-hour"}
                                style={{
                                    fontWeight: this.props.record.mean ? "bold" : undefined,
                                    backgroundColor: this.props.record.color,
                                    color: this.props.record.textColor,
                                }}
                            >
                                {this.props.record.mean.toFixed(DEFAULT_NUMBER_OF_FRACTION_DIGITS) + "°"}
                            </p>
                            {
                                this.props.showExtremes
                                 ? (
                                    <div
                                        className={"min-in-hour"}
                                        style={{
                                            backgroundColor: this.props.record.minBgColor,
                                            color: this.props.record.minTxColor,
                                        }}
                                    >
                                        <p>{this.props.record.min.toFixed(DEFAULT_NUMBER_OF_FRACTION_DIGITS) + "°"}</p>
                                    </div>
                                ) : null
                            }
                        </div>
                        {
                            this.props.record.thresholdsChanged
                                ? (<div
                                    style={{
                                        backgroundColor: DIFFERENT_THRESHOLD_WARNING_COLOR,
                                        width: "100%",
                                        height: "3px",
                                    }}
                                />) : null
                        }
                    </div>
                </div>
            </td>
        );
    }

    private toggleHover = (state) => () => {
        this.setState({hover: state});
    }
}
